export default "__VITE_ASSET__YkymdCwe__"